import { FirebaseApp } from "firebase/app";
import { Auth, User, UserCredential } from "firebase/auth";
import { Emitter } from "@ciaopeople/cp-shatsu/Queues";

interface AppleOAuthCredentials {
    idToken: string,
    accessToken: string 
}

class FirebaseWrapper {

    constructor(public readonly config) {
    }

    private getMod() {
        return import( /* webpackChunkName: "common/sdk/firebaseLogin" */ './FirebaseModule.js');
    }

    public preload() {
        this.getMod();
    }

    app(): Promise<FirebaseApp> {
        return this.getMod().then(
            e => e.app(this.config)
        );
    }
    auth(): Promise<Auth> {
        return this.getMod().then(
            e => e.auth(this.config)
        );
    }
    
    authStateChangeEmitter(): Promise<Emitter<User>> {
        return this.getMod().then(
            e => e.authStateChangeEmitter(this.config)
        );
    }

    appleSignInWithPopup(auth: Auth, scopes: string[]): Promise<UserCredential> {
        return this.getMod().then(
            e => e.appleSignInWithPopup(auth, scopes)
        );
    }

    appleSignInWithRedirect(auth: Auth, scopes: string[]): Promise<UserCredential> {
        return this.getMod().then(
            e => e.appleSignInWithRedirect(auth, scopes)
        );
    }

    credentialFromResult(result): Promise<AppleOAuthCredentials> {
        return this.getMod().then(
            e => e.credentialFromResult(result) as AppleOAuthCredentials
        );
        
    }

    getRedirectResult(): Promise<UserCredential|null> {
        return this.getMod().then(
            e => e.getRedirectResult(this.config)
        );
    }
    
}


export { FirebaseWrapper };